import JobPreferenceComponent from './JobPreferenceComponent';
import logoCircleDark from '../../assets/logos/logoCircleDark.png';
import {Button} from 'antd';
import {ArrowRightOutlined} from '@ant-design/icons';
import {ROUTES} from '../../utils/ROUTES';
import {useNavigate} from 'react-router-dom';

const JobPreferencePage = () => {
	const navigate = useNavigate();
	return (
		<div className="flex flex-col items-center justify-center mt-4">
			<div className="absolute top-0 right-0">
				<Button type="link" onClick={() => navigate(ROUTES.HOME)} icon={<ArrowRightOutlined />} iconPosition="end">
					skip for now
				</Button>
			</div>
			<div className="flex items-center gap-2 mt-4 sm:mt-0">
				<img className="w-4 h-4 object-contain" src={logoCircleDark} alt="permworks-logo" />
				<span className="text-[18px] text-deepBlue">Permworks</span>
			</div>{' '}
			<JobPreferenceComponent />
		</div>
	);
};

export default JobPreferencePage;
